import DashboardPassportReportItemModal from "./DashboardPassportReportItemModal";

export default DashboardPassportReportItemModal;
